import { error, pending, promiseState, success } from 'annotation-tools/utils';
import { ListItemWithPromiseState } from './list-item-with-status';
import { ListWithPromiseState } from './list-with-status';

export const getListItem = <T extends { id: number }>(
  listWithPromiseStatus: ListWithPromiseState<T>,
  id: number
): ListItemWithPromiseState<T> => {
  const itemOrNull = listWithPromiseStatus.value.latest.find(e => e.id === id);

  switch (listWithPromiseStatus.status) {
    case promiseState.pending:
      return pending({ latest: itemOrNull });

    case promiseState.error:
      return error({
        latest: itemOrNull,
        reason: listWithPromiseStatus.value.reason
      });

    case promiseState.success:
      return itemOrNull === undefined
        ? error({ latest: itemOrNull, reason: 'item-not-found' })
        : success({ latest: itemOrNull });
  }
};
